import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FadvModalComponent } from '@fa-switch-sharedservices/ng-elements';
import { Router } from '@angular/router';


@Component({
  selector: 'app-signed-consent-modal',
  templateUrl: './signed-consent-modal.component.html',
  styleUrls: ['./signed-consent-modal.component.less']
})
export class SignedConsentModalComponent implements OnInit {

  @ViewChild('signedConsentModal') signedConsentModal!: FadvModalComponent;
  @Output() consentEmitter: EventEmitter<boolean> = new EventEmitter();
  didConsent: boolean;



  constructor(private router: Router,
    ) { }

  hide() {
    this.signedConsentModal.hide();
  }

  show() {
    this.signedConsentModal.show();
  }

  onClick(){
    this.didConsent = true;
    this.consentEmitter.emit(this.didConsent);
    this.hide();
  }

  handleCancel(){
    this.didConsent = false;
    this.consentEmitter.emit(this.didConsent);
    this.hide();
  }

  ngOnInit(): void {
  }

}
